import { useToastStore } from "@/stores/useToastStore";

/** 完了まで進行中トーストを出して run を実行する。update で文言を差し替えられる。 */
export async function withLoadingToast<T>(
	message: string,
	run: (update: (message: string) => void) => Promise<T>,
): Promise<T> {
	const toasts = useToastStore.getState();
	const toastId = toasts.show({ type: "loading", message });
	try {
		return await run((next) => toasts.update(toastId, next));
	} finally {
		toasts.dismiss(toastId);
	}
}
